// 基础URL配置
export const baseUrl = process.env.NODE_ENV === 'development' 
  ? 'https://yxh.hhlxx.xyz' 
  : `https://yxhkf.xyz`



// 日期格式化
export const formatDate = (date, format = 'YYYY-MM-DD') => {
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  
  return format.replace('YYYY', year).replace('MM', month).replace('DD', day)
}

// 金额格式化
export const formatAmount = (amount) => {
  return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 防抖函数
export const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

// 验证手机号
export const validatePhone = (phone) => {
  return /^1[3-9]\d{9}$/.test(phone)
}

// 验证身份证
export const validateIDCard = (idCard) => {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(idCard)
}
